import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'components';
import DialogBody from './DialogBody';
import styles from './Dialog.scss'; // This just defines the body of the

var Dialog = /*#__PURE__*/function (_Component) {
  _inherits(Dialog, _Component);

  var _super = _createSuper(Dialog);

  function Dialog() {
    _classCallCheck(this, Dialog);

    return _super.apply(this, arguments);
  }

  _createClass(Dialog, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Popover, {
        open: this.props.open,
        content: /*#__PURE__*/React.createElement(DialogBody, _extends({}, this.props, {
          className: styles.dialog
        }))
      }, this.props.children);
    }
  }]);

  return Dialog;
}(Component);

_defineProperty(Dialog, "propTypes", {
  title: PropTypes.string,
  body: PropTypes.node,
  buttons: PropTypes.arrayOf(PropTypes.node).isRequired,
  open: PropTypes.bool.isRequired
});

export { Dialog as default };